"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_admin_1 = require("react-admin");
var Pagination_1 = __importDefault(require("@/Components/common/ReactAdmin/Pagination"));
var AppEditorListContent_1 = __importDefault(require("./AppEditorListContent"));
var AppEditorList = function (_a) {
    var versions = _a.versions, fetchVersions = _a.fetchVersions;
    (0, react_1.useEffect)(function () {
        fetchVersions();
    }, []);
    return (react_1.default.createElement("div", { style: { marginTop: "150px" } },
        react_1.default.createElement(react_admin_1.ListBase, { perPage: 100, resource: "app-editor/apps", queryOptions: {
                refetchOnWindowFocus: false,
                refetchOnReconnect: false,
                refetchOnMount: true,
                refetchInterval: 1000 * 60,
            }, filter: {
                "type[]": ["webcapture", "webapp", "dataapp"]
            } },
            react_1.default.createElement(AppEditorListContent_1.default, { versions: versions })),
        react_1.default.createElement(Pagination_1.default, { rowsPerPageOptions: [100, 250, 500, 1000] })));
};
exports.default = AppEditorList;
